/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Post_Purchase_DescriptionInputs */

const en_meta_post_purchase_description = /** @type {(inputs: Meta_Post_Purchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join Listening.com today and unlock a new audio experience. Listen to academic papers on the go. Sign up now to start your personalized experience and access exclusive features.`)
};

const es_meta_post_purchase_description = /** @type {(inputs: Meta_Post_Purchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a Listening.com hoy y desbloquea una nueva experiencia de audio. Escucha artículos académicos donde quieras. Regístrate ahora para comenzar tu experiencia personalizada y acceder a funciones exclusivas.`)
};

/**
* | output |
* | --- |
* | "Join Listening.com today and unlock a new audio experience. Listen to academic papers on the go. Sign up now to start your personalized experience and access..." |
*
* @param {Meta_Post_Purchase_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_post_purchase_description = /** @type {((inputs?: Meta_Post_Purchase_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Post_Purchase_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_post_purchase_description(inputs)
	return en_meta_post_purchase_description(inputs)
});